function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  fill: "#FF8D27",
  cx: 37.5,
  cy: 37.5,
  r: 36
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.5,3C56.523,3,72,18.477,72,37.5S56.523,72,37.5,72S3,56.523,3,37.5S18.477,3,37.5,3 M37.5,0C16.789,0,0,16.789,0,37.5 S16.789,75,37.5,75S75,58.211,75,37.5S58.211,0,37.5,0L37.5,0z"
}));

var SvgExtraLargeSelected = function SvgExtraLargeSelected(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "75px",
    height: "75px",
    viewBox: "0 0 75 75",
    enableBackground: "new 0 0 75 75",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExtraLargeSelected, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Extra-Large-Selected.1ad38483.svg";
export { ForwardRef as ReactComponent };